import { Link } from 'react-router-dom'
import { useTheme } from '../hooks/useTheme'

// styles
import './CardList.css'

export default function CardList({ cards }) {
    const { mode } = useTheme()


    return (
        <div className='card-list'>
            {cards.map(card => (
                <div key={card.id} className={`card ${mode}`}>
                    <h3>{card.title}</h3>
                    <div className='icon-container'>
                        <img src={card.icon} alt={`${card.title} icon`} className="card-icon"/>
                    </div>
                    <div>{card.detail.substring(0, 120)}...</div>
                    <Link to={`${card.link}`}>Learn More</Link>
                </div>
            ))}
        </div>
    )
}